import { Close } from '@emotion-icons/evaicons-solid';
import { IFormItem } from '~/store/slices/formSlice';
import { getAmount } from './helpers';
import styles from './invoiceform.module.scss';
import { IBaseSectionType } from './types';
import StyledInput from '~/components/StyledInput';
import TextButton from '~/components/TextButton';
import Gap from '~/components/Gap';
import { fmPrice } from '~/utils/amount';

const ItemSection = ({ setValue, formData }: IBaseSectionType) => {
  function onEditItem(itemIdx: number, itemData: Partial<IFormItem>) {
    const formItems = [...formData.items];
    const formItem = { ...formItems[itemIdx], ...itemData };
    formItems[itemIdx] = { ...formItem };
    setValue({ items: formItems });
  }

  function onAddItem() {
    const formItems = [...formData.items];
    formItems.push({
      sku: '',
      description: '',
      quantity: '1',
      price: '0',
    });
    setValue({ items: formItems });
  }

  function onRemoveItem(itemIdx: number) {
    const formItems = formData.items.filter((_, index) => index !== itemIdx);
    setValue({ items: formItems });
  }

  return (
    <div className={styles.itemContainer}>
      <table>
        <thead>
          <tr>
            <th>
              <div className={`${styles.cellDiv} ${styles.descCellDiv}`}>
                <p>
                  Description <span className="danger">*</span>
                </p>
              </div>
            </th>
            <th>
              <div className={styles.cellDiv}>
                <p>Quantity</p>
              </div>
            </th>
            <th>
              <div className={styles.cellDiv}>
                <p>Unit Price</p>
              </div>
            </th>
            <th>
              <div className={styles.cellDiv}>
                <p style={{ textAlign: 'right', width: '100px' }}>Amount</p>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {formData.items.map((eachItem: any, itemIdx: any) => (
            <tr key={itemIdx}>
              <td className="pl0">
                <div className={styles.cellDiv}>
                  <StyledInput
                    className={`${!eachItem['description'] && 'error-field'}`}
                    type="text"
                    value={eachItem['description']}
                    onChange={e => onEditItem(itemIdx, { description: e.target.value })}
                  />
                </div>
              </td>
              <td>
                <div className={styles.cellDiv}>
                  <StyledInput
                    className={`${!eachItem['quantity'] && 'error-field'}`}
                    type="text"
                    value={eachItem['quantity']}
                    onChange={e => onEditItem(itemIdx, { quantity: e.target.value })}
                  />
                </div>
              </td>
              <td>
                <div className={styles.cellDiv}>
                  <StyledInput
                    className={`${!eachItem['price'] && 'error-field'}`}
                    type="text"
                    value={eachItem['price']}
                    onChange={e => onEditItem(itemIdx, { price: e.target.value })}
                  />
                </div>
              </td>
              <td>
                <div className={styles.cellDiv}>
                  <p className="bold" style={{ textAlign: 'right', width: '100px' }}>
                    {fmPrice(formData.currency, getAmount(eachItem))}
                  </p>

                  <div
                    className={styles.closeButton}
                    style={{
                      opacity: itemIdx === 0 ? '0' : '1',
                      cursor: itemIdx === 0 ? 'inherit' : 'pointer',
                    }}
                    onClick={() => {
                      if (itemIdx !== 0) {
                        onRemoveItem(itemIdx);
                      }
                    }}
                  >
                    <Close size={15} />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Gap t={18} />
      <TextButton onClick={onAddItem}>+ Add Line Item</TextButton>
      <Gap t={18} />
    </div>
  );
};

export default ItemSection;
